import { FaTachometerAlt, FaCoffee, FaBoxOpen, FaCogs, FaDatabase, FaListUl, FaLayerGroup, FaFileInvoiceDollar, FaChartLine, FaChartPie, FaWarehouse } from "react-icons/fa";

export const MENU_ITEMS = [
  {
    path: "/admin/dashboard",
    name: "Dashboard",
    icon: FaTachometerAlt,
    roles: ["master", "admin"]
  },
  {
    path: "/admin/order",
    name: "Order (POS)",
    icon: FaCoffee,
    roles: ["master", "admin", "cashier"]
  },
  {
    path: "/admin/orders-history",
    name: "All Orders",
    icon: FaListUl,
    roles: ["master", "admin"]
  },
  {
    path: "/admin/kitchen",
    name: "Kitchen Board",
    icon: FaCogs,
    roles: ["master", "admin", "kitchen"]
  },
  {
    path: "/admin/delivery",
    name: "Delivery Board",
    icon: FaBoxOpen,
    roles: ["master", "admin", "rider"]
  },
  {
    name: "Master Data",
    icon: FaDatabase,
    roles: ["master", "admin", "kitchen"],
    subMenus: [
      {
        path: "/admin/menu",
        name: "Menu & Modifiers",
        icon: FaCoffee,
        roles: ["master", "admin"]
      },
      {
        path: "/admin/purchases",
        name: "Purchases (Invoices)",
        icon: FaFileInvoiceDollar,
        roles: ["master", "admin"]
      },
      {
        path: "/admin/inventory",
        name: "Inventory & Stock",
        icon: FaBoxOpen,
        roles: ["master", "admin", "kitchen"]
      },
      {
        path: "/admin/issues",
        name: "Issue Items (เบิกของ)",
        icon: FaBoxOpen,
        roles: ["master", "admin", "kitchen"]
      },
      {
        path: "/admin/transfers",
        name: "Transfers (โอนย้ายของ)",
        icon: FaBoxOpen,
        roles: ["master", "admin", "kitchen"]
      },
      {
        path: "/admin/discounts",
        name: "Discounts",
        icon: FaFileInvoiceDollar,
        roles: ["master", "admin"]
      },
      {
        path: "/admin/expenses",
        name: "Expenses Costs",
        icon: FaFileInvoiceDollar,
        roles: ["master", "admin"]
      }
    ]
  },
  {
    name: "Reports",
    icon: FaChartLine,
    roles: ["master", "admin"],
    subMenus: [
      {
        path: "/admin/reports/sales",
        name: "Sales & Revenue",
        icon: FaChartLine,
        roles: ["master", "admin"]
      },
      {
        path: "/admin/reports/profit",
        name: "Profit & Cost",
        icon: FaChartPie,
        roles: ["master", "admin"]
      },
      {
        path: "/admin/reports/inventory",
        name: "Inventory Reports",
        icon: FaWarehouse,
        roles: ["master", "admin"]
      }
    ]
  },
  {
    name: "Settings",
    icon: FaCogs,
    roles: ["master"],
    subMenus: [
      {
        path: "/admin/settings/general",
        name: "General Settings",
        icon: FaListUl,
        roles: ["master"]
      },
      {
        path: "/admin/settings/users",
        name: "User Management",
        icon: FaLayerGroup,
        roles: ["master"]
      },
      {
        path: "/admin/settings/branches",
        name: "Branch Management",
        icon: FaWarehouse,
        roles: ["master"]
      }
    ]
  }
];
